var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"add-btn d-flex",attrs:{"disabled":_vm.disabled,"data-cy":"form-add-item"},on:{"click":_vm.add}},[_c('Icon',{staticClass:"m-auto",attrs:{"name":"mdi.plus-thick"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }